<div class="app-container w-full">
  <router-outlet></router-outlet>
</div>
